module.exports = __webpack_public_path__ + "static/media/plans.adc2a43e.svg";